import { render } from "./land-section.vue?vue&type=template&id=4300ecb0"
import script from "./land-section.vue?vue&type=script&lang=js"
export * from "./land-section.vue?vue&type=script&lang=js"

import "./land-section.vue?vue&type=style&index=0&id=4300ecb0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__